module.exports = __webpack_public_path__ + "static/img/app-slide-show1.c32bade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images/app-slide-show1.png
// module id = wHOT
// module chunks = 44